/* eslint-disable prefer-arrow-callback*/
$(function () {
  const $navMenu = $('.js-smartphone-nav-menu');
  const $navArea = $('.js-smartphone-nav-area');
  const $navMenuTarget = $('.js-smartphone-nav-menu-target');
  const $navCloseBtn = $('.js-smartphone-nav-close-btn');

  if($navMenu.length === 0 || $navArea.length === 0 || $navMenuTarget === 0) return;

  $($navMenuTarget).on('click', (e) => {
    e.preventDefault();
    if ($navMenu.hasClass('js-smartphone-nav-menu-close') || $navMenu.hasClass('fade_in_right')) {
      $navMenu.removeClass('js-smartphone-nav-menu-close fade_in_right').addClass('fade_in_left');
      $navArea.addClass('js-full-screen-background');
      return $('body').addClass('js-category-page-overlay');
    } else {
      $navMenu.removeClass('fade_in_left').addClass('fade_in_right');
      $navArea.removeClass('js-full-screen-background');
      return $('body').removeClass('js-category-page-overlay');
    }
  });

  $navArea.on('click', closeNavMenu);
  $navCloseBtn.on('click', closeNavMenu);

  function closeNavMenu() {
    $navMenu.removeClass('fade_in_left').addClass('fade_in_right');
    $navArea.removeClass('js-full-screen-background');
    $('body').removeClass('js-category-page-overlay');
  }
});
/* eslint-disable prefer-arrow-callback*/
